import React, { useEffect } from 'react'
import styled from 'styled-components'
import ClampLines from 'react-clamp-lines'
import { Container } from '../style'
import BackChevron from '../images/chevron_left_white.svg'
import { handleEventLog } from '../../../lib/utils'

const TopImageSection = styled.section`
  width: 100%;
  background-repeat: no-repeat;
  position: relative;
`
const TopImg = styled.img`
  width: 100%;
  object-fit: contain;
`
const HeadDiv = styled.div`
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.7) 88.54%
  );
  background-blend-mode: soft-light;
  mix-blend-mode: normal;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px 24px;

  h2 {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 160%;
    text-transform: uppercase;
    color: #ffffff;
    margin: 4px 0;
  }
  p {
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    color: #ffffff;
  }
`
const BackArrowDiv = styled.div`
  background: rgba(239, 241, 241, 0.3);
  border-radius: 4px;
  position: absolute;
  top: 16px;
  left: 16px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
const DescriptionDiv = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 15px;
  letter-spacing: 0.01em;
  color: rgba(13, 21, 54, 0.65);
  width: 94%;
  margin: 16px auto;
`
const JoinNowBtn = styled.div`
  width: 94%;
  margin: auto;
  button {
    background: #214247;
    box-shadow: 0px 4px 4px rgba(104, 167, 176, 0.1);
    border-radius: 4px;
    outline: none;
    border: none;
    padding: 20px 40px;
    font-weight: 700;
    font-size: 14px;
    color: #ffffff;
  }
`
const IdeasHeading = styled.h2`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 28px;
  color: rgba(13, 21, 54, 0.65);
  width: 94%;
  margin: 16px auto;
`
const IdeasDiv = styled.div`
  background: radial-gradient(
      157.58% 157.58% at 59.76% -23.42%,
      #dfd4b8 0%,
      #ffffff 100%
    )
    /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
  box-shadow: 0px 10px 10px rgba(245, 245, 247, 0.1);
  border-radius: 8px;
  padding: 24px 16px 8px 16px;
  width: 94%;
  margin: auto;
`
const IdeaNumber = styled.p`
  margin: 0 8px 0 0;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 24px;
  letter-spacing: 0.01em;
  color: #9e906b;
`

const Idea = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 15px;
  letter-spacing: 0.01em;
  color: rgba(13, 21, 54, 0.65);
  padding-top: 3px;
`
const SampleBookCard = styled.div`
  width: 94%;
  margin: 16px auto;
  padding: 24px 16px;
  background: ${({ bg }) => bg};
  box-shadow: 0px 10px 10px rgba(245, 245, 247, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

const SampleBookCardImg = styled.img`
  width: 30%;
  object-fit: contain;
  border-radius: 4px;
`
const SampleBookDetails = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
`
const SampleBookText = styled.div`
  width: 55%;
`
const ReadNowBtn = styled.button`
  padding: 20px 40px;
  font-weight: 700;
  font-size: 14px;
  color: #ffffff;
  border-radius: 4px;
  outline: none;
  border: none;
  width: 55%;
  box-shadow: 0px 4px 4px rgba(104, 167, 176, 0.1);
  background: ${({ bg }) => bg};
`

const BookName = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.01em;
  color: rgba(13, 21, 54, 0.8);
`
const BookTags = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.01em;
  color: rgba(13, 21, 54, 0.8);
`
const BookDescp = styled.p`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.01em;
  color: rgba(13, 21, 54, 0.8);
  max-height: 160px;
  height: 20vw;
  overflow: hidden;
  .clamp-lines__button {
    display: none;
  }
`

const BooksBackground = [
  {
    bg: 'radial-gradient(82.53% 82.53% at 50% 50%, #ffb8b8 0%, #ffb8b8 0%, #ffffff 100%)',
    button: '#774040',
  },
  {
    bg: 'radial-gradient(82.53% 82.53% at 50% 50%, #ffdc94 0%, #ffdc94 0%, #ffffff 100%)',
    button: '#b98a2c',
  },
  {
    bg: 'radial-gradient(82.53% 82.53% at 50% 50%, #ddedf2 0%, #ddedf2 0%, #ffffff 100%)',
    button: '#35778b',
  },
]

function ThemesIdeasPage({
  themeData,
  setThemeDetailsOpen,
  handleJoinContestBtn,
  showNovelHandler,
  contestData,
}) {
  const isUSContest = contestData?.locale === 'US'
  useEffect(() => {
    handleEventLog(themeData.theme_name, 'page_load', {
      entity_id: contestData.contest_id,
      entity_type: 'theme',
    })
  }, [])

  const handleThemeHashTags = (hashString) => {
    return '#' + hashString.split(',').join(' #')
  }

  const handleBackArrow = () => {
    setThemeDetailsOpen({})
    handleEventLog(themeData.theme_name, 'button_click', {
      entity_id: contestData.contest_id,
      entity_type: 'contest',
      module_name: 'Back',
    })
    window.location.hash = ''
  }

  return (
    <Container>
      <TopImageSection>
        <TopImg src={themeData.image} />
        <HeadDiv>
          <h2>{themeData.theme_name}</h2>
          <p>{handleThemeHashTags(themeData.hash_tags)}</p>
        </HeadDiv>
        <BackArrowDiv onClick={handleBackArrow}>
          <img src={BackChevron} alt=""/>
        </BackArrowDiv>
      </TopImageSection>

      <section style={{ paddingBottom: '30px', background: '#F0E0E0' }}>
        <DescriptionDiv>{themeData.description}</DescriptionDiv>
        <JoinNowBtn>
          <button
            onClick={() =>
              handleJoinContestBtn(themeData.theme_name, {
                module_name: 'Join Now',
                entity_type: 'contest',
              })
            }
          >
            Join Now
          </button>
        </JoinNowBtn>
        <IdeasHeading>IDEAS 💡</IdeasHeading>
        <IdeasDiv>
          {themeData.ideas.map((idea, index) => (
            <div key={index} style={{ display: 'flex', marginBottom: '16px' }}>
              <IdeaNumber>{index + 1}.</IdeaNumber>
              <Idea>{idea}</Idea>
            </div>
          ))}
        </IdeasDiv>
        <IdeasHeading>{isUSContest ? 'SAMPLE SHOWS/AUDIOBOOKS' : 'BOOK SAMPLES 📚'}</IdeasHeading>
        {themeData.example_books.length > 0 &&
          themeData.example_books.map((book, index) => (
            <SampleBookCard bg={BooksBackground[index % 3].bg}>
              <SampleBookDetails>
                <SampleBookCardImg src={book?.image_url} />
                <SampleBookText>
                  <BookName>{book?.book_title}</BookName>
                  <BookTags>{book?.category}</BookTags>
                  <BookDescp>
                    <ClampLines lines={2} text={book?.description} />
                  </BookDescp>
                </SampleBookText>
              </SampleBookDetails>
              <ReadNowBtn
                bg={BooksBackground[index % 3].button}
                onClick={() => showNovelHandler(book?.book_id, book?.isAudiobook)}
              >
                {book?.isAudiobook ? 'Listen Now' : 'Read Now'}
              </ReadNowBtn>
            </SampleBookCard>
          ))}
      </section>
    </Container>
  )
}

export default ThemesIdeasPage
